import { imgUrl } from "@/lib/api";

export function HostProfile({ host }) {
  if (!host) return null;
  const level = host.star_level || 3;
  const isElite = level === 5;
  const initial = (host.name || "H").trim().charAt(0).toUpperCase();

  return (
    <section data-testid="host-profile" className="border-t border-[#EBEBEB] pt-8">
      <h2 className="text-xl font-display font-semibold mb-4">Meet your host</h2>
      <div className="flex items-center gap-5 bg-white border border-[#EBEBEB] rounded-2xl p-5">
        <div className="relative shrink-0">
          {host.picture ? (
            <img
              data-testid="host-avatar"
              src={imgUrl(host.picture)}
              alt={host.name}
              className="w-20 h-20 rounded-full object-cover"
              onError={(e) => { e.currentTarget.style.display = "none"; }}
            />
          ) : (
            <div className="w-20 h-20 rounded-full bg-[#FF385C] text-white flex items-center justify-center text-2xl font-display font-bold">
              {initial}
            </div>
          )}
          {isElite && (
            <span data-testid="host-elite-badge" className="absolute -bottom-1 -right-1 bg-[#FFB400] text-white text-[10px] font-bold px-1.5 py-0.5 rounded-full border-2 border-white">
              ★
            </span>
          )}
        </div>

        <div className="flex-1 min-w-0">
          <p className="text-lg font-display font-semibold text-[#222]" data-testid="host-name">
            Hosted by {host.name}
          </p>
          <div className="flex items-center gap-2 mt-1" data-testid="host-star-badge">
            <span className="text-[#FFB400] tracking-tight text-base leading-none" aria-label={`${level} star host`}>
              {"★".repeat(level)}
              <span className="text-[#DDD]">{"★".repeat(5 - level)}</span>
            </span>
            <span className={`text-xs font-semibold px-2 py-0.5 rounded-full ${isElite ? "bg-[#FFB400]/15 text-[#B37A00]" : "bg-[#F0F0F4] text-[#222]"}`}>
              {host.star_label}
            </span>
          </div>
          <p className="text-sm text-[#717171] mt-1.5">
            {host.since ? `Host since ${host.since}` : "New host"}
            {host.property_count > 0 && ` · ${host.property_count} ${host.property_count === 1 ? "property" : "properties"}`}
          </p>
        </div>
      </div>
    </section>
  );
}
